import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Breakpoint, ButtonProps } from "@mui/material";
interface ConfirmDialogProps {
  title?: string;
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  okLabel?: string;
  okColor?: ButtonProps["color"];
  isOkDisabled?: boolean;
  /** Optional save action (e.g. persist edits before discard). */
  onSave?: () => void;
  saveLabel?: string;
  saveColor?: ButtonProps["color"];
  isSaveDisabled?: boolean;
  hideCancelButton?: boolean;
  cancelLabel?: string;
  cancelColor?: ButtonProps["color"];
  maxWidth?: false | Breakpoint;
  fullWidth?: boolean;
  children: React.ReactNode;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = (props) => {
  return (
    <Dialog
      maxWidth={props.maxWidth}
      fullWidth={props.fullWidth}
      open={props.open}
      onClose={() => props.onCancel()}
      aria-labelledby="confirm-dialog"
    >
      {props.title ? (
        <DialogTitle id="confirm-dialog">{props.title}</DialogTitle>
      ) : (
        <></>
      )}
      <DialogContent>{props.children}</DialogContent>
      <DialogActions>
        {!props.hideCancelButton && (
          <Button
            variant="contained"
            onClick={() => props.onCancel()}
            color={props.cancelColor ?? "primary"}
          >
            {props.cancelLabel ? props.cancelLabel : "Cancel"}
          </Button>
        )}
        {props.onSave && (
          <Button
            variant="contained"
            color={props.saveColor ?? "primary"}
            disabled={props.isSaveDisabled}
            onClick={() => {
              props.onSave?.();
            }}
          >
            {props.saveLabel ? props.saveLabel : "Save"}
          </Button>
        )}
        <Button
          variant="contained"
          color={props.okColor ?? "primary"}
          disabled={props.isOkDisabled}
          onClick={() => {
            props.onOk();
          }}
        >
          {props.okLabel ? props.okLabel : "OK"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmDialog;
